import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/icons')({
  beforeLoad: () => getTitleContextSlice('Icons'),
  staticData: {
    owner: CodeOwner.Uvm,
  },
});
